<template>
  <layout-horizontal>

    <router-view />

    <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    />

    <my-page
      v-if="showMyPage"
      slot="customizer"
    />
  </layout-horizontal>

</template>

<script>
import LayoutHorizontal from '@core/layouts/layout-horizontal/LayoutHorizontal.vue'
import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
import MyPage from '../../views/apps/my-page/MyPage.vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    LayoutHorizontal,
    AppCustomizer,
    MyPage,
  },
  data() {
    return {
      showCustomizer: $themeConfig.layout.customizer,
      showMyPage: $themeConfig.layout.myPage,
    }
  },
}
</script>
